import RecessAPI from '@services/RecessAPI'
# import RecessRT from '@services/RecessRT'
import HubspotService from '@services/HubspotService'
import SupplyRoutes from '@modules/host/routes.js'
import PartnerBuyRoutes from '@modules/partnerBuy/routes.js'
import SponsorRoutes from '@modules/sponsor/routes.js'
import SuperRoutes from  '@modules/super/routes.js'
import isEqual from 'lodash.isequal'
import queue from "queue";
import Cookies from 'js-cookie'
import { MessageBox, Message } from 'element-ui'
import {matchSort, elementUIOptionsSort} from  '@utils/sort.coffee'

VUE_STASH_CACHE_TTL = parseInt(process.env.VUE_APP_VUE_STASH_CACHE_TTL || 30)  #milliseconds
# 1 Only pages should access router params
# 2 All variables for a component must be passed as props
# i.e. showing a component on a page, the page will need to pull the id out of the route and pass it to the component

API_FETCH_QUEUE = queue({ autostart: true, concurrency: 3 })
API_FETCH_INFINITE_QUEUE = queue({ autostart: true, concurrency: 1 })
API_SAVE_QUEUE = queue({ autostart: true, concurrency: 1 })
API_UPLOAD_QUEUE = queue({ autostart: true, concurrency: 1 })

setRequestIsPending = ->
  window.Vue.store.requestIsPending = true

resetRequestIsPending = ->
  window.Vue.store.requestIsPending = false if 0 is API_FETCH_QUEUE.length and 0 is API_FETCH_INFINITE_QUEUE.length and 0 is API_SAVE_QUEUE.length

cookieExpiresAfterDays = parseInt(process.env.VUE_APP_SESSION_EXPIRES_AFTER_DAYS || 30)
cookieAPI = Cookies.withAttributes({ expires: cookieExpiresAfterDays, secure: true, sameSite: 'strict' })
setSaveRequestIsPending = ->
  window.Vue.store.saveRequestIsPending = true

resetSaveRequestIsPending = ->
  window.Vue.store.saveRequestIsPending = false if 0 is API_SAVE_QUEUE.length

StringMethods =
  camelify: (value) ->
    fn = (match, p1, p2, offset) ->
      return p2.toUpperCase() if (p2)
      return p1.toLowerCase()
    return "#{value}".replace(/^([A-Z])|[\s-_]+(\w)/g, fn)

  titleize: (value) ->
    camelified = @camelify(value)
    camelified.charAt(0).toUpperCase() + camelified.substr(1)

ResourceMethods =
  errorsPresent: ->
    hasErrors = false
    (@formErrors[resourceKey] = null if 0 is errors.length) for resourceKey, errors of @formErrors when errors? # convert empty arrays to null
    (hasErrors = true ) for resourceKey, errors of @formErrors when errors?
    hasErrors
  errorFor: (resourceSelector) -> @errorForResourceSelector(resourceSelector)
  errorForResourceField: (resourceKey, field) -> @errorsForResourceKey(resourceKey)[field]
  errorForResourceSelector: (resourceSelector) ->
    tokns = resourceSelector.split('.')
    field = tokns.pop()
    resourceKey = tokns.join('.')
    @errorForResourceField(resourceKey, field)
  errorsForResourceKey: (resourceKey) ->
    key = resourceKey.replace 'prime.', ''
    @formErrors[key] || {}
  setErrorsForResourceKey: (resourceKey, errorObject) ->
    @formErrors[resourceKey] = errorObject
  primeForResourceKey: (resourceKey) ->
    @debug "primeForResourceKey: #{resourceKey}"
    key = resourceKey.replace('prime.', '')
    @prime[key]
  dataResourceForResourceKey: (resourceKey) ->
    @debug "primeForResourceKey: #{resourceKey}"
    @[resourceKey]

  resourcesForResourceDefinitions: ->
    @debug "resourcesForResourceDefinitions"
    models = {}
    models[resourceKey] = @resourceForResourceKey(resourceKey) for resourceKey, def of @resourceDefinitions()
    models

  resourceForResourceKey: (resourceKey) ->
## POSSIBLY NEED TO USE MODEL SLUG HERE ????????
    @debug "resourceForResourceKey: #{resourceKey}"
    slug = @slugForResourceKey resourceKey
    @debug "resourceForResourceKey - model:", @models[slug], @models
    @dereferenceSlug slug

  dereferenceSlug: (slug) ->
    appSlug = RecessAPI.slugForApp slug
    reference = @slugs[appSlug]
    return null unless reference?
    return @dereferenceCollection reference if Array.isArray reference
    model = @dereferenceOne reference
    model

  dereferenceOne: (reference) ->
    if !reference? or [reference.klass, reference.id].includes null
      console.warn "klass and id for a reference can not be null!", reference
      return null
    @models[reference.klass][reference.id]

  dereferenceCollection: (references) ->
    collection = []
    for ref in references
      model = @dereferenceOne ref
      collection.push model if model?
    collection

  resourceNameForResourceKey: (resourceKey) ->
    @debug "resourceNameForResourceKey: #{resourceKey}"
    @resourceDefinitions()[resourceKey]['resourceName']

  infinityScrollForResourceKey: (resourceKey) ->
    @debug "resourceNameForResourceKey: #{resourceKey}"
    !!@resourceDefinitions()[resourceKey]['infinityScroll']

  apiSlugForResourceKey: (resourceKey) ->
    @debug "apiSlugForResourceKey: #{resourceKey}"
    @throw "resource does not exist for key: #{resourceKey}" unless @resourceDefinitions()[resourceKey]?
    slug =  @resourceDefinitions()[resourceKey].apiSlug || @resourceDefinitions()[resourceKey].slug
    apiSlug = @resolveSlug(slug) if slug?
    apiSlug
  constantForResourceKey: (resourceKey) ->
    @debug "constantForResourceKey: #{resourceKey}"
    @throw "resource does not exist for key: #{resourceKey}" unless @resourceDefinitions()[resourceKey]?
    @resolveSlugToken @resourceDefinitions()[resourceKey].constant
  hasConstantForResourceKey: (resourceKey) -> @resourceDefinitions()[resourceKey]?.constant?
  slugForResourceKey: (resourceKey) ->
    @debug "slugForResourceKey: #{resourceKey}"
    @throw "resource does not exist for key: #{resourceKey}" unless @resourceDefinitions()[resourceKey]?
    slug = @resourceDefinitions()[resourceKey].slug
    @throw "no slug for resource key: #{resourceKey}" unless slug?
    @resolveSlug(slug)

  paramsForResourceKey: (resourceKey) ->
    resourceParams = @resourceDefinitions()[resourceKey]?['params'] || {}
    params = {}
    params[key] = @resolveSlug(value) for key, value of resourceParams
    params

  resolveSlug: (slug) ->
    return null unless slug?
    return false if 'false' is "#{slug}".toLowerCase()
    return true if 'true' is "#{slug}".toLowerCase()
    tokens = "#{slug}".split('/')
    values = (@resolveSlugToken(token) for token in tokens)
    resolvedSlug = values.join('/')
    resolvedSlug = resolvedSlug[1..-1] if resolvedSlug[0] is '/'
    @debug "resolveSlug - resolvedSlug: #{resolvedSlug}"
    resolvedSlug

  resolveSlugToken: (token) ->
    @debug "resolveSlugToken: #{token}"
    return token unless token[0] is ':'
    @debug 'resolving token :', token, @
    t = token[1..-1]
    tokns = t.split('.')
    obj = tokns.shift()
    scope = @[obj]
    scope ||= @$parent?[obj]
    scope ||= @$root?[obj]
    scope = scope?[att] for att in tokns
    scope ||= @$router.currentRoute.params[t] if @$router?.currentRoute?.params[t]?
    scope ||= @$router.currentRoute.query[t] if @$router?.currentRoute?.query[t]?
    scope
  lookupResources: ->
    for resourceKey, value of @resourcesForResourceDefinitions()
      if @hasConstantForResourceKey resourceKey
        @[resourceKey] = @constantForResourceKey resourceKey
      else
        @[resourceKey] = value
  imageRoot: -> process.env.VUE_APP_AWS_ASSETS_BUCKET || "assets.live.marketplace"
  imageFor: (bucketPath, name)-> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/#{bucketPath}/#{name}"

SessionMethods =
  getComponentSession: (key) -> @$store.componentSession[@constructor.name]?[@_uid]?[key]
  setComponentSession: (key, value) ->
    @$store.componentSession[@constructor.name] ||= {}
    @$store.componentSession[@constructor.name][@_uid] ||= {}
    @$store.componentSession[@constructor.name][@_uid][key] = value
  getAppSession: (key, defaultValue=null) ->
    v = @$store.appSession[key]
    @setAppSession(key, defaultValue) if not v?
    v ||= @$store.appSession[key]
  setAppSession: (key, value) ->
    return unless @appSession?
    session = {...@appSession}
    session[key] = value
    session.now = Date.now()
    @appSession = session
    @saveStash()

  pushAppSession: (key, value) ->
    list = [...@getAppSession(key, [])]
    list.push(value)
    @setAppSession(key, list)

  removeFromAppSessionList: (key, value, field=null) ->
    list = @getAppSession(key, [])
    fn = (item) =>
      if field?
        item[field] != value[field]
      else
        item != value

    list = list.filter(fn)
    @setAppSession(key, list)

  getPageSession: (key, defaultValue=null) ->
    v = @$store.pageSession[key]
    @setPageSession(key, defaultValue) if not v?
    v ||= @$store.pageSession[key]
    v
  setPageSession: (key, value) ->
    return unless @pageSession?
    session = {...@pageSession}
    session[key] = value
    session.now = Date.now()
    @pageSession = session
    @saveStash()
  removeFromPageSession: (key) ->
    return unless @pageSession?
    session = {...@pageSession}
    delete session[key]
    session.now = Date.now()
    @pageSession = session
    @saveStash()

  showFlash: (flash) ->
    return unless flash?
    for key in Object.keys(flash)
      messageType = @titleize(key)
      messageType = "" if "Info" is messageType
      @$notify group: 'toast', text: "#{messageType} #{flash[key]}"
  showFlashError: (flashErrors) ->
    @showFlash(flashErrors)

APIMethods =
  resourceIsLoaded: (resource)->
    if typeof resource is "string"
      model = @[resource]
      model ||= @prime?[resource]
    model = resource if typeof  resource is "object"
    model? and not model?.slim # heuristic to look for an item with all attributes (not slim)
  resourceIsLoading: (resource) -> !@resourceIsLoaded(resource)
  fetch: (resourceKey, fetchParams = {})->
    _this = this
    API_FETCH_QUEUE.push((cb) ->
      response = await _this.fetchJob(resourceKey, fetchParams)
      cb()
    )
  fetchJob: (resourceKey, fetchParams = {})->
    try
      resourceSlug = @apiSlugForResourceKey(resourceKey)
      params = @paramsForResourceKey(resourceKey)
      params[k] = v for k,v of fetchParams
      event = await RecessAPI.fetch(resourceSlug, params)
      @fireEvent resourceKey, event
    catch err
      @onFetchFail err

  fetchBySlug: (slug, params = {})->
    try
# resourceSlug = @apiSlugForResourceKey(resourceKey)
      event = await RecessAPI.fetch(slug, params)
      @fireEvent resourceKey, event
    catch err
      @onFetchFail err

  fetchAllResources: (options={}) ->
    for resourceKey, def of @resourceDefinitions()
      if def.constant?
        @[resourceKey] = @resolveSlugToken def.constant
      else
        unless def.infinityScroll # If infinityScroll let the widget handle the fetching
          continue if (def.fetch? and def.fetch is false) and !options.force
          continue if def.lazy and @[resourceKey]
          @fetch(resourceKey) unless @resourceIsCachedForResourceKey resourceKey
  fetchInfinity: (state, resourceKey, data = {}, options={}) ->
# return if @requestIsPending
    { page } = options
    @infinityScroll.page += 1
    @infinityScroll.page = page if page?

    @clearDataForResourceKey(resourceKey) if !state

    infinityEnabled = @infinityScrollForResourceKey(resourceKey)
    console.error("Infinity scroll not configured properly. Resource #{resourceKey}.infinityScroll = true needs to be set", infinityEnabled) unless infinityEnabled

    page = @infinityScroll.page

    params = { page }
    params.scopes = @formatFilterScopes(data.scopes) if data?.scopes?
    params.filters = data.filters if data?.filters?
    params.bi_filters = data.bi_filters if data?.bi_filters?
    params.multi_filters = data.multi_filters if data?.multi_filters?
    params.type_filters = data.type_filters if data?.type_filters?
    params.geo_filters = data.geo_filters if data?.geo_filters?
    params.q = data.q
    params.sort = data.sort if data?.sort?
    params.target = data.target if data?.target?
    params.filter_scope = data.filter_scope if data?.filter_scope?

    _this = this

    API_FETCH_INFINITE_QUEUE.push((cb) ->
      _this.fetchJob(resourceKey, params).then((response) ->
        console.error('Infinity scroll not configured properly') unless response?.collection?
        return unless state
        { count, page, per_page } = response.scroll
        if count > page * per_page
          state.loaded()
        else
          state.complete()
      ).finally(() ->
        resetRequestIsPending()
        cb()
      )
    )

  fetchWithoutStoring: (slug, params = {})->
    try
      event = await RecessAPI.fetch(slug, params)
      event.item || event.collection
    catch err
      @onFetchFail err

  fetchProgressBars: ->
    try
      { data } = await RecessAPI.fetchProgressBars()
      @setAppSession 'progress_bars', data.collection
      return data.collection
    catch err
      console.error(err)

  fetchProgress: (key, step) ->
    try
      { progress } = await RecessAPI.fetchProgress { key, step }
      return progress
    catch err
      console.error(err)

  saveItem: (resourceKey, item = null, options = {}) ->
    _this = this
    API_SAVE_QUEUE.push((cb) ->
      response = await _this.saveItemJob(resourceKey, item, options)
      cb()
    )

  saveItemField: (resourceKey, fieldNames, options = {}) ->
    fields = fieldNames if Array.isArray(fieldNames)
    fields ||= [fieldNames]
    key = resourceKey.replace('prime.', '')
    obj = @primeForResourceKey key
    obj ||= @dataResourceForResourceKey key
    payload = {}
    payload['id'] = obj.id if obj.id?
    payload[fieldName] = obj[fieldName] for fieldName in fields
    @saveItem("prime.#{key}", payload, options)

  saveItemJob: (resourceKey, item = null, options = {}) ->
    key = resourceKey.replace('prime.', '')
    resourceName = @resourceNameForResourceKey key
    resourceSlug = @apiSlugForResourceKey key
    resourceSlug = resourceSlug[0..-5] if resourceSlug.toLowerCase().endsWith('/new') ## when creating a new item, post to collection slug
    resourceSlug = resourceSlug[0..-6] if resourceSlug.toLowerCase().endsWith('/edit') ## when editing an item, patch to item slug
    if resourceKey.startsWith('prime.')
      item ||= @primeForResourceKey key
    else
      item ||= @dataResourceForResourceKey key
    try
      event = await RecessAPI.saveItem(resourceSlug, resourceName, item)
      @fireEvent key, event, options
      savedItem = event.item || event.prime?.item
      if !options.skipCallbacks
        if @errorsPresent()
          @onSaveError(savedItem) unless options.skipFlash
        else
          @onSave(savedItem)
    catch err
      console.log err
      ## handle API failure
      @onSaveFail(resourceKey, item, options)
    finally
      resetRequestIsPending()
      resetSaveRequestIsPending()
  save: (resourceSlug, resourceName, item, options={}) ->
    key = options.key
    try
      event = await RecessAPI.saveItem(resourceSlug, resourceName, item)
      @fireEvent key, event, options
      savedItem = event.item || event.prime?.item

      if @errorsPresent()
        @onSaveError(savedItem)
      else
        @onSave(savedItem)
    catch err
## handle API failure
      console.log err
    finally
      resetRequestIsPending()
      resetSaveRequestIsPending()

  exportCsvParams: (resourceKey, data = {}) ->
    params = {}
    params.scopes = @formatFilterScopes(data.scopes) if data?.scopes?
    params.filters = data.filters if data?.filters?
    params.multi_filters = data.multi_filters if data?.multi_filters?
    params.q = data.q
    params.sort = data.sort if data?.sort?
    params

  triggerAction: (action, data) ->
    try
      event = await RecessAPI[action]?(data)
      @fireAction action, event
    catch err
      console.log err

  triggerResource: (resourceKey, action, data) ->
    _this = this
    API_SAVE_QUEUE.push((cb) ->
      response = await _this.triggerResourceJob(resourceKey, action, data)
      cb()
    )

  triggerResourceJob: (resourceKey, action, data) ->
    key = resourceKey.replace('prime.', '')
    resourceSlug = @apiSlugForResourceKey key
    resourceSlug = resourceSlug[0..-5] if resourceSlug.toLowerCase().endsWith('/new') ## when creating a new item, post to collection slug
    resourceSlug = resourceSlug[0..-6] if resourceSlug.toLowerCase().endsWith('/edit') ## when editing an item, patch to item slug

    try
      event = await RecessAPI.triggerResource(resourceSlug, action, data)
      @fireEvent key, event
      unless @errorsPresent() # also, check the eventfor any errors
        response = event.item || event.prime?.item
        response ||= event.collection
        response ||= event
        handlerName = @handlerNameFor action
        @[handlerName]?(response)
        # notify component that trigger was successful
        triggerCallbackName = @handlerNameFor "#{key}-#{action}"
        @[triggerCallbackName]? data, response
        @onResourceTriggerCompleted key, event
      else
        console.error(@formErrors)
    catch err
      @onFetchFail err

  triggerSlug: (resourceSlug, action, data) ->
    try
      event = await RecessAPI.triggerResource(resourceSlug, action, data)
      @fireEvent key, event
      unless @errorsPresent() # also, check the event for any errors
        response = event.item || event.prime?.item
        response ||= event.collection
        response ||= event
        handlerName = @handlerNameFor action
        @[handlerName]?(response)
        # notify component that trigger was successful
        triggerCallbackName = @handlerNameFor "#{resourceKey}-#{action}"
        @[triggerCallbackName]? data, response
    catch err
      console.log err
  destroyAttachment:  (id)->
    await RecessAPI.destroyAttachment(id)

  onFetchFail: (err) ->
    switch err.response.status
      when 403 then @logout()
      else console.error(err)

  uploadFile: (path, file) ->
    new Promise((resolve) =>
      API_UPLOAD_QUEUE.push((cb) =>
        RecessAPI.uploadFile(path, file).then(resolve).then(cb)
      )
    )

  isLoggedIn: () -> @$store.member?.id?
  isPartnerBuy: -> @$route.path.startsWith('/buy')
  currentMember: () -> @$store.member
  currentMemberIsSupplier: ()-> 'supplier' is @$store.member?.market_type
  currentMemberIsSponsor: ()-> 'buyer' is @$store.member?.market_type
  currentMemberIsSuperUser: ()-> @$store.member?.super_user

  ensureNoMember: ->
    return unless @$store.member?.id
    @clearStash()
    window.location.reload()

  setCurrentMember: (member) ->
    return @logout() if  "#{window.location.pathname}".toLowerCase() is "/logout"
    return @logout() unless member?.token?
    RecessAPI.configureAppForMember member
    # RecessRT.init()
    @$store.member = member
    @saveStash()
    @$router.addRoutes @routesForCurrentMember()
    # @intercomHeartbeat()

  routesForCurrentMember: ()->
    member = @currentMember()
    routes = SupplyRoutes if @currentMemberIsSupplier()
    routes = SponsorRoutes if @currentMemberIsSponsor()
    routes = SuperRoutes if @currentMemberIsSuperUser()
    routes = PartnerBuyRoutes if @isPartnerBuy()
    routes

  navigateToDashboard: () ->
    return @logout { saveRef: true } unless @$store.member?.token?
    @fetchMarketplaceConfig() # fire off in parallel while we navigate
    dashboard = @dashboardForSupplier() if @currentMemberIsSupplier()
    dashboard = @dashboardForPartnerBuy() if @isPartnerBuy()
    dashboard = @dashboardForSponsor() if @currentMemberIsSponsor()
    dashboard = @dashboardForSuperUser() if @currentMemberIsSuperUser()

    routeName = ''
    routeQuery = null
    routeParams = null
    if typeof dashboard is 'string'
      routeName = dashboard
    else
      routeName = dashboard.name
      routeQuery = dashboard.query
      routeParams = dashboard.params

    HubspotService.submitHubspotForm(@$store.member.email, @$route) if !@currentMemberIsSuperUser() and @$store.member.sign_in_count == 1
    @$router.replace({ name: routeName, query: routeQuery, params: routeParams })
# @$router.replace({ name: routeName, query: routeQuery}, () => @$router.go(0)) # Reactivity breaks after login, reload the page is hack to fix it

  dashboardForSupplier: () ->
    member = @$store.member
    dashboard = @dashboardForCurrentSupplier()
    dashboard = 'OnboardOrganizer' unless member.onboarded
    # Waitlist takes precedence over onboarding for supplier
    dashboard = 'WaitListOrganizer' if member.wait_listed
    dashboard

  dashboardForSponsor: () ->
    dashboard = @dashboardForCurrentSponsor()
    dashboard

  dashboardForPartnerBuy: () ->
    dashboard = { name: 'BrandRepCreatePage' } 
    dashboard

  dashboardForSuperUser: ()->
    dashboard = @dashboardForCurrentSuperUser()
    dashboard

  dashboardForCurrentSupplier: ()->
    dashboard = { name: "AudienceCreativeListPage" }
    dashboard = "AudienceCreativeCreatePage" unless @$store.member.audience_creative_count > 0
    dashboard = { name: 'OfferListPage', query: { scope: 'submitted' } } if @$store.member.organizer?.ctx?.stats?.offer?.pending_count
    dashboard
  dashboardForCurrentSponsor: ()->
    member = @$store.member
    { campaigns } = member.brand_rep

    if campaigns?.length is 0
      dashboard = 'CampaignCreatePage'
    else if member.wait_listed
      dashboard = 'WaitListSponsor' # welcome
    else if campaigns?.length is 1
      dashboard = { name: 'CampaignEventFeedStage', params: { campaignId: campaigns[0].id } }

    dashboard ||= 'CampaignListPage'
    dashboard

  dashboardForCurrentSuperUser: ()->
    "VenueListPage"

  initializePartnerBuy: ->
    return unless @isPartnerBuy
    @initializePartnerBuyRoutes()

  initializePartnerBuyRoutes: ->
    @$router.addRoutes PartnerBuyRoutes unless @$route.name?.length
    RecessAPI.configureAppForPartnerBuy @getAppSession('partnerBuy', {})

  logout: (options={}) ->
    try
      await RecessAPI.logout() if @$store.member?.token
    finally
      @clearStash()
      loginURL = @makeLoginUrl { saveRef: options.saveRef }
      url = options.path if options.path
      url ||= loginURL
      window.location.href = url unless loginURL is window.location.href

  makeLoginUrl: ({ saveRef = false }) ->
    url = new URL "#{window.location.origin}/login"

    if @$route.query.ref
      url.searchParams.set 'ref', @$route.query.ref
    else if saveRef
      ref = new URL window.location.href
      ref = ref.toString().replace ref.origin, ''
      url.searchParams.set 'ref', ref unless ref in ['/', '/login']

    url.toString()

  switchUser: (member_id) ->
    response = await RecessAPI.switchUser member_id
    @error = response.errors.error if response.errors?
    if !response.errors?
      @impersonateUser(response.item)
      window.location.href = window.location.origin

  refetchMember: ->
    response = await RecessAPI.fetchMe()
    @error = response.errors.error if response.errors?
    @setCurrentMember(response.item) if !response.errors?
    response.item

  fetchMarketplaceConfig: ->
    response = await RecessAPI.fetchMarketplace()
    @$store.marketplace = response.item.config
    @$options.filters.initializeMarketplace(@$store.marketplace)

  clearStash: () ->
    @$store[key] = {} for key, value of @$store
    @$store['requestIsPending'] = false
    @$store['saveRequestIsPending'] = false
    @$store['models']['now'] = Date.now()
    @clearCookie()
    localStorage.removeItem 'rcstsh'

  clearCookie: () ->
    cookieAPI.remove('cookie')

  loadStash: () ->
    try
      json = localStorage.getItem('rcstsh')
      stash = JSON.parse(json) || {}
      @$store[key] = value for key, value of stash
      @loadCookie()
    catch err
      console.error err
      @clearStash()

  loadCookie: () ->
    cookieStr = cookieAPI.get('cookie')
    return unless cookieStr
    @$store.cookie = JSON.parse cookieStr
    @$store.member.token = @$store.cookie.memberToken
    @$store.originalMember.token = @$store.cookie.originalMemberToken

  saveStash: () ->
    { appSession, pageSession, member, originalMember } = @$store
    data = { appSession, pageSession }
    data.member = { ...member }
    data.originalMember = { ...originalMember }
    delete data.member.token
    delete data.originalMember.token

    try
      stash = JSON.stringify(data)
      localStorage.setItem('rcstsh', stash)
      @saveCookies()
    catch err
      console.error err
      @clearStash()

  saveCookies: ->
    cookie = {
      memberToken: @$store.member.token,
      originalMemberToken: @$store.originalMember.token,
    }
    cookieStr = JSON.stringify cookie
    cookieAPI.set('cookie', cookieStr)

  impersonateUser: (member) ->
    @$store.originalMember = @$store.member
    @$store.originalMember.lastUrl = window.location.href
    @setCurrentMember member

  stopImpersonating: ->
    originalMember = { ...@$store.originalMember }
    @$store.originalMember = {}
    @setCurrentMember originalMember

  destroyItem: (resourceKey) ->
    key = resourceKey.replace('prime.', '')
    try
      resourceSlug = @apiSlugForResourceKey key
      event = await RecessAPI.destroyItem(resourceSlug)
      @fireEvent key, event
    catch err
      console.error err
## handle API failure
  destroy: (resourceSlug, key, options={}) ->
    key = options?.key || resourceSlug
    try
      event = await RecessAPI.destroyItem(resourceSlug)
      @fireEvent key, event, options
    catch err
      console.error err
## handle API failure
  handlerNameFor: (name)->
    handler = name.replace(/_/g, "-").replace(/\b-([a-z])/g, (_, char) -> char.toUpperCase())
    handler = "on#{"#{handler.charAt(0).toUpperCase()}#{handler.substr(1)}"}"
    handler
  fireAction: (action, event, options={}) ->
    handlerName = @handlerNameFor action
    @showFlashError(event.errors)
    @[handlerName]?(event, options) unless event.errors?
    @models['now'] = Date.now()
  fireEvent: (resourceKey, event, options={}) ->
    @loadPrimeOptionsAndContext(event)
    handlerName = @handlerNameFor event.type
    @throw 'handler name does not exist' unless @[handlerName]?
    @setErrorsForResourceKey(resourceKey, event.errors)
    @showFlash(event.flash) unless options.skipFlash
    @[handlerName]?(resourceKey, event, options)
    @models['now'] = Date.now()
    return event
  resourceIsCachedForResourceKey: (resourceKey) ->
    model = @resourceForResourceKey(resourceKey)
    return false if model?.slim
    slug = @slugForResourceKey(resourceKey)
    appSlug = RecessAPI.slugForApp slug
    slugObject = @slugs[appSlug]
    return false unless slugObject?.ts?
    (Date.now() - slugObject.ts <= VUE_STASH_CACHE_TTL)
  loadDataIntoModels: (data, options) ->
    if Array.isArray data
      @loadDataIntoStorage obj.slug, obj, options for obj in data
    else if "object" is typeof data
      {id, klass} = data
      @throw 'data needs id and klass to be set' unless id? and klass?
      @models[klass] ||= {}
      deepData = @preserveDeepData(data) # preserve deep relations in data if previously fetched
      @models[klass][id] = deepData

      for prop, val of data
        continue unless val?
        arrayifiedValue = @flatten [val]
        first = arrayifiedValue[0]
        continue unless "object" is typeof first
        continue unless first?.slug?
        @loadDataIntoStorage obj.slug, obj, options for obj in arrayifiedValue

  clearDataForResourceKey: (resourceKey) ->
    slug = @slugForResourceKey resourceKey
    @clearDataForSlug slug

  clearDataForSlug: (slug) ->
    appSlug = RecessAPI.slugForApp slug
    @slugs[appSlug] = null
    @lookupResources()

  loadDataIntoSlugs: (slug, data, options = {}) ->
    ts = Date.now()
    appSlug = RecessAPI.slugForApp slug
    if Array.isArray data
      elements = @slugs[appSlug] if options?.infinityScroll?.infinityScroll && options?.infinityScroll?.page > 1
      elements ||= []

      for obj in data
        {id, klass} = obj
        refObj = { id, klass, ts }
        elements.push refObj
        @slugs["#{appSlug}/#{id}"] = refObj
      @slugs[appSlug] = elements
    else
      {id, klass} = data
      console.log data unless id?
      console.log 'id needs to be set' unless id?
      console.log 'klass needs to be set' unless klass?
      return null if !id or !klass
      @slugs[appSlug] = {id , klass, ts}

  loadDataIntoStorage: (slug, data, options = {}) ->
    return unless slug?
    options.visited ||= []
    return if options.visited[slug]?
    options.visited[slug] = true
    ref = @loadDataIntoSlugs slug, data, options
    @loadDataIntoModels data, options if ref
    @lookupResources()

  preserveDeepData: (data) ->
# return data
# 1) fetch deep eventset, returns relations/dependencies (eventset.events, eventset.offers, ...)
# 2) fetch shallow eventset, does not return relations/dependencies
# 3) function preserves previous model relations/dependencies instead of clobbering w/ shallow data
    {id, klass} = data
    previousData = @models[klass][id]
    data = JSON.parse(JSON.stringify(data))
    return data unless previousData?
    data.slim = false if false is previousData.slim # preserve slim state if all attributes were previously loaded
    for field, value of previousData
      continue if data[field]? or "object" isnt typeof(value)
      data[field] = previousData[field]
    @processSubDataUIEvents(previousData, data) if data["ui_events"]? # adds new data and updates the existing data instead of entirely replacing it.
    data

  processSubDataUIEvents: (previousData, data) ->
    for field in (data.ui_events?.load ||  [])
      mergedValues = @loadSubData(previousData[field], data[field])
      data[field] = mergedValues
    for field in (data.ui_events?.unload ||  [])
      mergedValues = @unloadSubData(previousData[field], data[field])
      data[field] = mergedValues
    delete data["ui_events"]
    data

  loadSubData: (values, changedValues) ->
    valueMap = {}
    changedValueMap = {}
    valueMap[v.id] = v for v in values
    changedValueMap[v.id] = v for v in changedValues
    finalValues = []
    finalValues.push(changedValueMap[v.id] || v) for v in values
    for v in changedValues
      finalValues.push(v) unless valueMap[v.id]?
    finalValues

  unloadSubData: (values, removedValues) ->
    removeValueMap = {}
    removeValueMap[v.id] = v for v in removedValues
    finalValues = []
    for v in values
      finalValues.push(v) unless removeValueMap[v.id]
    finalValues

  loadPrimeOptionsAndContext: (event)->
    return unless event.prime?
    @prime = { ...@prime, options: event.prime.options } if event.prime.options?
    @prime = { ...@prime, context: event.prime.context } if event.prime.context?
  onLoadPrime: (resourceKey, event) ->
    @prime[resourceKey] = event.prime.item
    @onLoadPrimeCompleted resourceKey, event
  onLoadItem: (resourceKey, event, options={}) ->
    slug = options.slug || event.item?.slug
    data = event.item
    @loadDataIntoStorage slug, data
    @onLoadItemCompleted resourceKey, event
  onLoadCollection: (resourceKey, event, options={}) ->
    slug = options.slug || event.slug
    data = event.collection
    options.infinityScroll = @infinityScroll || {}
    options.infinityScroll.infinityScroll = @infinityScrollForResourceKey(resourceKey)
    @loadDataIntoStorage slug, data, options
    @onLoadCollectionCompleted resourceKey, event
  onUnloadItem: (resourceKey, event, options={}) ->
    id = options.id || event.item?.id
    slug = options.slug || event.item?.slug
    klass = options.klass || event.item?.klass
    delete @slugs[slug]
    delete @models[klass][id]
    @onUnloadItemCompleted resourceKey, event
  onUnloadCollection: (resourceKey, event, options={}) ->
    collectionSlug = options.slug || event.slug
    delete @models[collectionSlug]
    @onUnloadCollectionCompleted resourceKey, event
  onCollectionLoadItem: (resourceKey, event, options={}) ->
    collectionSlug = options.slug || event.slug
    { id, klass } = event.item
    @models[klass] ||= {}
    @models[klass][id] = event.item
    @slugs[collectionSlug] ||= []
    @slugs[collectionSlug].push { id, klass }
    @models[klass] = { ...@models[klass] }
    @slugs = { ...@slugs }
    @onCollectionLoadItemCompleted resourceKey, event
  onCollectionUnloadItem: (resourceKey, event) ->
    collectionSlug = event.slug
    { id, klass } = event.item
    filteredSlugs = @slugs[collectionSlug]?.filter((i) -> i.id isnt id)
    delete @models[klass][id]
    @slugs[collectionSlug] = filteredSlugs
    @models[klass] = { ...@models[klass] }
    @onCollectionUnloadItemCompleted resourceKey, event
  onLoadPrimeCompleted: (resourceKey, event) ->
  onLoadItemCompleted: (resourceKey, event) ->
  onUnloadItemCompleted: (resourceKey, event) ->
  onUnloadCollectionCompleted: (resourceKey, event) ->
  onLoadCollectionCompleted: (resourceKey, event) ->
  onCollectionUnloadItemCompleted: (resourceKey, event) ->
  onCollectionLoadItemCompleted: (resourceKey, event) ->
  onResourceTriggerCompleted: (resourceKey, event) ->
  onSave: (item) ->
  onSaveError: (item) ->
    for resource, flashErrors of @formErrors
      @showFlashError(flashErrors) if flashErrors?
  onSaveFail: (resourceKey, item, options) ->

UtilMethods =

  standardPricingTable: -> @marketplace?.standard_pricing_table || {}

  faIconClass: (key, options={})->
    iconCSSMapping = @$store.marketplace?.icon_css_mapping || {}
    synonyms = iconCSSMapping.synonyms || {}
    iconCSS = iconCSSMapping.icon_css || {}
    key = "#{key}".trim().toLowerCase().replaceAll(" ", "-").replaceAll("_", "-")
    key = synonyms[key] if synonyms[key]?
    if options.defaultKey? and !iconCSS[key]?
      key = "#{options.defaultKey}".trim().toLowerCase().replaceAll(" ", "-").replaceAll("_", "-")
    css = iconCSS[key]

    if options.style?
      style = options.style.toLowerCase().charAt(0)
      css = css[0..1] + style + css[3..-1] if ['r', 'l', 'd', 's'].includes style
    css = "#{css} #{options.css}" if options.css?
    css

  isEmptyValue: (value) ->
    return true unless value
    return value.every(@isEmptyValue) if Array.isArray value
    return Object.values(JSON.parse(JSON.stringify(value))).every(@isEmptyValue) if typeof value is 'object'
    false

  isEmpty: (value) -> !value? || "#{value}".trim() is ''
  isFalsy: (value) ->
    ['no', 'n', 'false', 'f', ''].includes "#{value}".toLowerCase()
  isTruthy: (value) ->
    value? and (['yes', 'y', 'true', 't'].includes("#{value}".toLowerCase()) || !@isFalsy(value))
  isMicrosoftBrowser: ->
    ua = window.navigator.userAgent
    return true if (ua.indexOf('MSIE ') > 0)
    return true if (ua.indexOf('Trident/') > 0)
    return true if (ua.indexOf('Edge/') > 0)
    return false
  intercomHeartbeat: ->
    return unless @$intercom?
    return @$intercom.shutdown() if @currentMemberIsSuperUser()
    lastIntercomUpdate = @getAppSession("lastIntercomUpdate") || 0
    if @$store?.member?.email? and Date.now() > lastIntercomUpdate + 20000
      userId = @$store?.member?.legacy?.id
      userId ||= @$store?.member?.id
      intercomPayload = { }
      intercomPayload.email = @$store?.member?.email
      intercomPayload.user_id = userId
      @$intercom.update intercomPayload
      @setAppSession "lastIntercomUpdate", Date.now()
  isOnMaintenanceMode: ->
    !!@$store.marketplace?.maintenance_mode

  scrollTo: (selector, y = 0) -> document.querySelector(selector)?.scroll({ top: y, behavior: 'smooth' })

  scrollElementTo: (element, y = 0) ->
    element.scroll({ top: y, behavior: 'smooth' })

  scrollContainerTo: (containerSelector, elementSelector, offset = 30) ->
    y = document.querySelector(elementSelector).offsetTop - offset
    @scrollTo(containerSelector, y)

  format: (formatter, ...args) ->
    formatName = "format#{@$options.filters.formatCapitalized(formatter)}"
    @$options.filters[formatName]?(args)

  parsePrice: (value) -> parseFloat("#{value}".replace(/,/g, ''))

  firstInitial: (name, ifBlank="")-> "#{name || ifBlank}"[0]

  legacyID: (obj)-> obj?.legacy?.id || obj?.legacy_id

  jsonToElementUICascader: (jsonTree, mapping={}, parent=null)->
    target=[]
    for category, subcat of jsonTree
      label = mapping[category] || category
      idPrefix = if parent then "#{parent.id}." else ''
      cascade =
        id: idPrefix + category 
        label: @format('title', label)
      subcatIsTree = subcat? and not (typeof subcat is 'string' || subcat instanceof String)
      if subcatIsTree
        cascade.children = @jsonToElementUICascader(subcat, mapping, cascade)
        cascade.children.push { id: "#{cascade.id}.other", label: "Other" }
      target.push cascade
    target

  hashToElementUIOptions: (data, order=[])->
    list = ({ id, name } for id, name of (data||{}))
    elementUIOptionsSort list, order

  resolveDotPath: (obj, dotPath)->
    data = obj || {}
    return data unless dotPath?
    tokens = dotPath.split('.')
    (data = data[token] || {}) for token in tokens
    data

  ctxFor: (key, obj, dotPath) ->
    @resolveDotPath obj?.ctx?[key], dotPath
  ctxStats: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.stats, dotPath
  ctxState: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.state, dotPath
  ctxImages: (obj)->
    obj?.ctx?.images || obj?.images || []
  ctxInvoice: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.invoice, dotPath
  ctxRemittance: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.remittance, dotPath
  ctxOwner: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.owner, dotPath
  ctxMember: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.member, dotPath
  ctxHost: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.host, dotPath
  ctxSchools: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.host?.schools, dotPath
  ctxSocialMediaAccounts: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.host?.social_media_accounts, dotPath
  ctxEvent: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.event, dotPath
  ctxEventSet: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.event_set, dotPath
  ctxEventOwner: (obj, dotPath)->
    @resolveDotPath @ctxEvent(obj).owner, dotPath
  ctxPricingTable: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.pricing_table, dotPath
  ctxDiscountTable: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.discount_table, dotPath
  ctxUniversity: (obj, dotPath)->
    data = obj?.ctx?.university || @ctxEvent(obj)?.university
    @resolveDotPath data, dotPath
  ctxSupplierOrg: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.supplier?.org, dotPath
  ctxSupplierSubOrg: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.supplier?.sub_org, dotPath
  ctxSupplierSubOrgs: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.supplier?.sub_orgs, dotPath
  ctxSponsorOrg: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.sponsor?.org, dotPath
  ctxSponsorSubOrg: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.sponsor?.sub_org, dotPath
  ctxSponsorSubOrgs: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.sponsor?.sub_orgs, dotPath
  ctxBrand: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.brand, dotPath
  ctxBrands: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.brands, dotPath
  ctxScanner: (obj, dotPath)->
    @resolveDotPath obj?.ctx?.scanner, dotPath
  ctxBrandRep: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.brand_rep, dotPath
  ctxOrganizer: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.organizer, dotPath
  ctxOffer: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.offer, dotPath
  ctxPurchaseOrder: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.purchase_order, dotPath
  ctxEventInstances: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.instances, dotPath
  ctxCampaign: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.campaign, dotPath
  ctxSponsorSet: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.sponsor_set, dotPath
  ctxPartnerShareLink: (obj, dotPath) ->
    obj?.ctx?.partner_share_link
  ctxImageURL: (obj) -> @ctxImages(obj)[0]?.url
  ctxHeroImageURL: (obj) -> @ctxImages(obj)[0]?.hero_url || @ctxImageURL(obj)
  ctxThumbImageURL: (obj) -> @ctxImages(obj)[0]?.thumb_url
  ctxAudienceListing: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.audience_listing, dotPath
  ctxVendorListing: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.vendor_listing, dotPath
  ctxOmnichannel: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.omnichannel, dotPath
  ctxShippingArea: (obj, dotPath) ->
    @resolveDotPath obj?.ctx?.shipping_area, dotPath

  listFromText: (text, delimiters...)->
    delimiters.push "," unless delimiters.length
    t = "#{text}".replace ///#{delimiter}///g, '\n' for delimiter in delimiters
    tokens = t.split '\n'
    list = []
    for token in tokens
      s = token.trim()
      list.push s if s.length
    list

  ifDebug: (functor, args...)->
    if @debugMode
      functor?(args...)
    else
      console.log "This function is only available in debug mode"
  resourceListIsEmpty: (resourceList) -> @resourceIsLoaded(resourceList) and 0 is (resourceList || []).length
  tabIsActive: (tabName) -> @$route.params.tab is tabName
  pageIsActive: (pageName) -> @$route.name is pageName
  cloneObject: (obj) -> Object.assign {} , obj
  uniq: (array = []) ->
    [...new Set(array)]
  compact: (array = []) ->
    array.filter((item) => item)
  flatten: (array) ->
    array.reduce(((x, y) => if Array.isArray(y) then x.concat(@flatten(y)) else x.concat(y)), [])
  pluck: (array, key) ->
    array.map((item) => item[key])
  distinct: (array, key) ->
    @uniq @pluck(array, key)
  chunkArray: (array = [], chunkSize = 10) ->
    array.slice(i, i + chunkSize) for i in [0...array.length] by chunkSize
  objectsAreEqual: (obj, ref) -> isEqual(obj, ref)
  throw: (msg) ->
    name = @$options._componentTag
    console.error "ERROR!!:#{@_uid}:#{name}", msg
    throw msg
  debug: (...args) ->
    name = @$options._componentTag
# console.info "DEBUG:#{@_uid}:#{name}:", args
  rerender: -> @$nextTick => @$forceUpdate()
  titlelize: (title) ->
    t = title.charAt(0).toUpperCase() + title[1..-1]
    t.replace(/_/g, ' ')
  showAlert: (message, title = 'Alert', options = { showClose: false, center: true, confirmButtonClass: 'text-base px-4 py-3' }) ->
    MessageBox.alert(message, title, options)
  showMessage: (message ) -> Message({ message: message })
  launchTab: (url, target) ->
    event?.stopPropagation()
    event?.preventDefault()
    window.open(url, target)

  copyToClipboard: (event, value) ->
    clipboardData = event.clipboardData || window.clipboardData || event.originalEvent?.clipboardData || navigator.clipboard
    clipboardData.writeText value

  launchV1App: (path, target) -> @launchTab "https://app-v1.recess.is#{path}", target

  hiNoPass: (event) ->
    event.stopPropagation()

  stringDayToDayJS: (date) -> # convert year/month/day to local time by adding utcOffset() so the dates stays the same
    return null if !date
    dayjs(date[0..9]).subtract(dayjs().utcOffset(), 'minute')

  formatFilterScopes: (scopes) ->
    Object.values(scopes).filter((value) -> value if value).join(',')

  iconForSpaceType: (type) ->
    switch type
      when 'food_truck' then 'fad fa-truck-container'
      when 'trailer' then 'fas fa-trailer'
      when 'product_sampling' then 'far fa-gifts'
      when 'video_wall' then 'fad fa-film'
      when 'native_integration' then 'fab fa-youtube'
      when 'social_media_post' then 'far fa-comment-alt'
      when 'title_sponsor' then 'fas fa-newspaper'
      else 'fas fa-warehouse'

  iconForSpace: (space) -> @iconForSpaceType space.type

  iconForPlatform: (website) ->
    switch "#{website}".replace(/_/g, '').toLowerCase()
      when 'website' then 'fas fa-globe'
      when 'facebook' then 'fab fa-facebook-square'
      when 'instagram' then 'fab fa-instagram'
      when 'twitter' then 'fab fa-twitter'
      when 'youtube' then 'fab fa-youtube'
      when 'twitch' then 'fab fa-twitch'
      when 'vimeo' then 'fab fa-vimeo'
      else 'fas fa-circle'

  icon: (value) ->
    switch "#{value}".replace(/_/g, '').toLowerCase()
      when 'wifi' then 'far fa-wifi'
      when 'tent' then 'fas fa-campground'
      when 'chairs' then 'fas fa-chair'
      when 'power' then 'fas fa-power-off'
      when 'ice' then 'fas fa-refrigerator'
      when 'tables' then 'fas fa-game-board-alt'
      when 'lighting' then 'far fa-lightbulb'
      when 'parking' then 'fas fa-parking'
      when 'trashbins' then 'fas fa-trash'
      when 'recyclebins' then 'fas fa-recycle'
      when 'other' then 'fas fa-layer-plus'
      else 'fas fa-circle'

  instantBookingEnabled: (event) ->
    return false unless event.instant_booking_enabled
    return true unless event.instant_booking_allowed_brand_ids.length # all brands are permited if empty
    event.instant_booking_allowed_brand_ids.includes @ctxBrand(event).id

  toSelectOptions: (object) ->
    { value, label } for value, label of object

  campaignCreativeForSpace: (space, creatives = {}) ->
    creatives[space.type]?.find((creative) =>
      switch space.type
        when 'product_sampling'
          return true
        when 'onsite_space'
          return true if creative.type is "booth_#{space.size}"
      return false
    )

LifeCyleMethods =
  beforeCreate:  -> @debug?('~LIFE:beforeCreate : ' +  @_uid)
  created:       ->
    @debug?('~LIFE:created: ' +  @_uid)
    @initializePartnerBuy() if @isPartnerBuy()
  beforeMount:   ->
    @debug?('~LIFE:beforeMount: ' +  @_uid)
    @lookupResources()
    @fetchAllResources()
    # @intercomHeartbeat()
  mounted:       -> @debug?('~LIFE:mounted: ' +  @_uid)
  beforeUpdate:  -> @debug?('~LIFE:beforeUpdate : ' +  @_uid)
  updated:       -> @debug?('~LIFE:updated: ' +  @_uid)
  beforeDestroy: -> @debug?('~LIFE:beforeDestroy : ' +  @_uid)
  destroyed:     -> @debug?('~LIFE:destroyed: ' +  @_uid)

vueComponents = (settings)-> settings.components

vueMethods = (settings)->
  methods = {}
  resourceDefinitions = settings.resources if settings.resources?

  for methodSet in [StringMethods, ResourceMethods, SessionMethods, APIMethods, UtilMethods]
    methods[name] = functor for name, functor of methodSet
    methods['resourceDefinitions'] = -> resourceDefinitions || @resourceDefinitionsProp
  methods

vueDataForResources = (settings)->
  resourceDefinitions = settings.resources if settings.resources?
  ->
    debugMode = 'true' is "#{process.env.VUE_APP_DEBUG_MODE}".trim().toLowerCase()
    infinityScroll = { page: 0, per_page: 50 }
    properties = { formErrors: {}, prime: {}, infinityScroll, debugMode }
    for resourceKey, def of resourceDefinitions
      properties[resourceKey] = null
      properties.prime[resourceKey] = null
      properties.formErrors[resourceKey] = []
    properties

vueComputedProperties = (settings)->
  resourceDefinitions = settings.resources if settings.resources?
  computedValues =
    restore: ->
      m = @models?.now || 0
      s = @appSession?.now || 0
      Math.max(m, s)
# resourceDefinitions: -> resourceDefinitions

vueDirectives = (settings)->
  directives = {}

vueWatch = (settings)->
  restore: -> @lookupResources()

class VueOptions
  @initialize: ->
    API_FETCH_QUEUE.on('start', setRequestIsPending)
    API_FETCH_INFINITE_QUEUE.on('start', setRequestIsPending)
    API_SAVE_QUEUE.on('start', () =>
      setRequestIsPending()
      setSaveRequestIsPending()
    )

    for ev in ['end', 'success', 'error']
      API_FETCH_QUEUE.on(ev, resetRequestIsPending)
      API_FETCH_INFINITE_QUEUE.on(ev, resetRequestIsPending)
      API_SAVE_QUEUE.on(ev, () =>
        resetRequestIsPending()
        resetSaveRequestIsPending()
      )

    setInterval(resetRequestIsPending, 1000) # safeguard

  @vue: (settings = {})->
# All config.methods run in the Vue context meaning @ = Vue instance
    config =
      store: ["appSession", "pageSession", "cookie", "componentSession", "requestIsPending", "saveRequestIsPending", "marketplace", "models", "slugs"]
      components: vueComponents(settings)
      data: vueDataForResources(settings)
      directives: vueDirectives()
      methods: vueMethods(settings)
      computed: vueComputedProperties(settings)
      watch: vueWatch(settings)
    config[name] = method for name, method of LifeCyleMethods
    for category, methods of settings.vue # settings is the vue options defined in each vue component
      if config[category]? and typeof(methods) is 'object'
        for method, fn of methods
          console.info "Overriding default method for #{category}.#{method}" if config[category][method]?
          config[category][method] = fn
      else
        console.info "Overriding default setting for #{category}=#{config[category]?[methods]} with #{methods}" if config[category]?[methods]?
        if category is 'data' # override config.data to wrap both data methods (from from the vue component and from VueOptions framework)
          vueDataForResourcesFn = config[category]
          dataFn = methods
          dataMethod = ->
            properties = vueDataForResourcesFn()
            newProperties = dataFn.call(this) # the vue.data() method
            Object.assign(properties, newProperties)
          config[category] = dataMethod
        else
          config[category] = methods
    config

export default VueOptions
